<template>
  <div>
    <Card :bordered="true">
      <template slot="title">{{$t('index.login')}}</template>
      <Form ref="form" :model="form">
        <FormItem prop="email">
          <i-Input type="text" v-model="form.email" required :placeholder="$t('manage.login')" @on-enter="handleSubmit">
            <Icon type="ios-person-outline" slot="prepend"></Icon>
          </i-Input>
        </FormItem>
        <FormItem prop="number">
          <i-Input type="text" v-model="form.number" required :placeholder="$t('license.number')" @on-enter="handleSubmit">
            <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </i-Input>
        </FormItem>
        <FormItem>
          <Button type="primary" class="right" :loading="submitting" @click="handleSubmit">
            <span v-if="!submitting">{{$t('index.login')}}</span>
            <span v-else>{{$t('loading')}}...</span>
          </Button>
        </FormItem>
      </Form>
    </Card>
    <Card :bordered="true" v-if="!fromResourcePage">
      <template slot="title">{{$t('index.feide.login')}}</template>
      <a :href="rootUrl + '/auth/login/feide?target=/license/login'">{{$t('index.feide.login')}}</a>
    </Card>
  </div>
</template>

<script>
import axios from 'axios';
import {mapState} from 'vuex';

export default {
  name: 'Login',
  mounted() {
    if (this.isLoggedIn) {
      this.$router.push('manage');
    } else {
      axios.get(process.env.VUE_APP_ROOT_API + '/api/license').then(response => {
        this.$store.dispatch('license/logIn');
        this.$store.dispatch('license/set', response.data);
        this.$router.push('manage');
      }).catch(() => {
        // ignored
      });
      axios.get(process.env.VUE_APP_ROOT_API + '/auth/csrf').then(response => {
        this.form._csrf_token = response.data.token;
      });
    }
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.license.isLoggedIn
    }),
    fromResourcePage() {
      if (this.$route.query.o === 'res')
        window.isResourcePage = true;

      return window.isResourcePage;
    }
  },
  data() {
    return {
      rootUrl: process.env.VUE_APP_ROOT_API,
      submitting: false,
      form: {
        email: null,
        number: null,
        _csrf_token: null,
      }
    }
  },
  methods: {
    handleSubmit() {
      this.submitting = true;
      axios.post(process.env.VUE_APP_ROOT_API + '/auth/login/', this.form).then(response => {
        this.submitting = false;
        if (response.data.status === 'success') {
          this.$store.dispatch('license/logIn');
          this.$router.push("/manage");
        } else {
          this.$store.dispatch('license/logOut');
          this.$Message.error({content: response.data.message, duration: 5});
        }
      }).catch(error => {
        this.submitting = false;
        this.$store.dispatch('license/logOut');
        this.$Message.error({content: error.message, duration: 5});
      });
    }
  }
}
</script>

<style lang="scss">
.ivu-input::placeholder {
  color: #5e6779 !important;
}
@include respond-to(phone) {
  .ivu-input-wrapper {
    border: 1px solid #45526c;
    border-radius: 5px;
  }

  .ivu-input::placeholder {
    color: #45526c !important;
  }
}
</style>

<style scoped lang="scss">
.main-content {
  text-align: center;

  .ivu-card {
    width: 50%;
    text-align: center;
    margin: 40px auto;

    @include respond-to(phone) {
      width: 95%;
    }
    @include respond-to(tablet) {
      width: 85%;
    }
  }

  form {
    width: 50%;
    margin: 25px auto;

    @include respond-to(phone) {
      width: 95%;
    }
    @include respond-to(tablet) {
      width: 85%;
    }
  }

  @include respond-to(phone) {
    button {
      width: 100%;
    }
  }

  .right {
    float: right;
  }
}
</style>